import { FC } from 'react';
import * as ScrollArea from '@radix-ui/react-scroll-area';

interface CourseNameListProps {
  names: string[];
}

export const CourseNameList: FC<CourseNameListProps> = ({ names }) => (
  <ScrollArea.Root className="h-40 overflow-hidden rounded border border-(--neutral-black-NB200)">
    <ScrollArea.Viewport className="h-full w-full p-2">
      <ul className="flex flex-col gap-1 m-0 pl-3">
        {names.map((name, index) => (
          <li key={`${name}-${index}`} className="text-sm text-(--neutral-black-NB900) font-medium">
            {name}
          </li>
        ))}
      </ul>
    </ScrollArea.Viewport>

    <ScrollArea.Scrollbar orientation="vertical" className="flex w-1.5 touch-none select-none p-px">
      <ScrollArea.Thumb className="relative flex-1 rounded-full bg-(--neutral-black-NB300)" />
    </ScrollArea.Scrollbar>
  </ScrollArea.Root>
);
